export class WorkflowAPIModel {
  WorkflowAPI: string = "";
  WorkflowDetailsAPI: string = "";
  JournalList: string = "";
  ArticleList: string = "";
  PublisherList: string = "";
  IssueList: string = "";
  ArticleTypeList: string = "";
  DeleteWorkflow: string = "";
  DropdownValues: string = "";
  WorkflowUpdate: string = "";
  CheckDuplicate: string = "";
  SelectOptions: string = "";

  FailedMsg: string = "";
  WorkflowActivityErrorMsg: string = "";
  DuplicateActivityErrorMsg: string = "";
  ActivityErrorMsg: string = "";
  DisplayNameErrorMsg: string = "";
  DaysErrorMsg: string = "";
  HoursErrorMsg: string = "";
  WorkflowErrorMsg: string = "";
  PublisherErrorMsg: string = "";
  DescriptionErrorMsg: string = "";
  DuplicateWorkflowErrorMsg: string = "";
  DeleteTitle: string = "";
  DeleteText: string = "";
}
